<template>
  <el-table
    :data="avaliationItemResponses"
    class="table-responsive table-striped"
    header-row-class-name="thead-light"
    style="width: 100%;"
  >
    <el-table-column label="Respondente" prop="name" width="270px" />
    <el-table-column
      v-for="avaliationItem in avaliationItems"
      :key="avaliationItem.id"
      min-width="190px"
      :label="avaliationItem.name"
      v-slot="{ row }"
    >
      {{ formatResponse(row, avaliationItem) }}
    </el-table-column>
    <el-table-column label="Resultado (Média Ponderada)" prop="calculated_data.wavg" width="270px" v-slot="{ row }">
      {{ (row.calculated_data.wavg || 0).toLocaleString('pt-BR') }}
    </el-table-column>
  </el-table>
</template>

<script>
import {
  Table,
  TableColumn,
} from "element-ui";

export default {
  name: "AvaliationItemResultsList",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    avaliationItemResponses: {
      type: Array,
      required: true,
    },
    avaliationItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatResponse(row, avaliationItem) {
      if (!(row.avaliation_item_responses && row.avaliation_item_responses.length)) return null;

      const avaliation_item_response = row.avaliation_item_responses.find(air => air.avaliation_item_id === avaliationItem.id)

      if (!avaliation_item_response) return null;

      const response = avaliation_item_response.response;


      if (avaliationItem.strategy === "number" || avaliationItem.strategy === "likert_scale") {
        const val = parseFloat(response);
        if (!val) return val;
        return val.toLocaleString('pt-BR');
      }

      if (avaliationItem.strategy === "boolean") {
        if (response === 'T')    return "Sim";
        if (response === 't')    return "Sim";
        if (response === 'v')    return "Sim";
        if (response === 's')    return "Sim";
        if (response === 'TRUE') return "Sim";
        if (response === 'Y')    return "Sim";
        if (response === 'F')    return "Não";
        if (response === 'f')    return "Não";

        return "Não";
      }

      if (avaliationItem.strategy === "date") {
        return this.$options.filters.formatDate(response);
      }

      return response;
    },
  },
}
</script>
